export default __webpack_public_path__ + "static/media/imageContentOne.42d95af0.png";